/**
 * @fileoverview Barrel exports for the plot-synopsis-merge-v3 agent.
 */

export { definition } from './definition';
export { flow, plotSynopsisMergeV3AgentFlow } from './flow';
export { InputSchema, OutputSchema } from './schema';
export type { Input, Output } from './schema';
export { prompt } from './prompt';
